import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export interface Options {
  rangeFrom?: string;
  rangeTo?: string;
  adjustDates?: boolean;
  exclusionId?: number;
}

export default (makeCall: MakeCall) => (listingId: number, options?: Options) =>
    makeCall<undefined>('DELETE', `/api/v2/listing/${listingId}`, {
      query: { ...options },
    });
